(() => {
  // eslint-disable-next-line no-new, no-undef
  new Swiper(".related-products__swiper", {
    slidesPerView: 2.2,
    spaceBetween: 15,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        allowSlideNext: false,
        allowSlidePrev: false,
        allowTouchMove: false,
      },
    },
  });
})();
